import AbcIcon from "@mui/icons-material/Abc";
import FolderSpecialIcon from "@mui/icons-material/FolderSpecial";
import EditIcon from "@mui/icons-material/Edit";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import AssignmentIcon from "@mui/icons-material/Assignment";
import Diversity1Icon from "@mui/icons-material/Diversity1";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import MailIcon from "@mui/icons-material/Mail";
import MenuIcon from "@mui/icons-material/Menu";
import QuizIcon from "@mui/icons-material/Quiz";
import SensorOccupiedIcon from "@mui/icons-material/SensorOccupied";
import SchoolIcon from "@mui/icons-material/School";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import GroupIcon from "@mui/icons-material/Group";
import PsychologyIcon from "@mui/icons-material/Psychology";
import BugReportIcon from "@mui/icons-material/BugReport";
import {
  AppBar,
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Tooltip,
} from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { IdeaIcon, LogoutIcon, QuestionIcon, TwoPeopleIcon } from "../../../assets/icons";
import logoIcon from "../../../assets/logo.svg";
import { KeyTokenName, ROUTES, appVersion } from "../../../constants";
import { ERole, IApplicationState, AllTypeActions } from "../../../store-redux";
import ChatAIPopup from "@/pages/CMS/ChatAIPopup";

const drawerWidth = 240;
const collapsedDrawerWidth = 60;

interface Props {
  children: React.ReactNode;
}

const dashboardRoutes = [
  {
    path: ROUTES.CMS_ADMIN_DASHBOARD,
    name: "Tổng quan",
    icon: <AnalyticsIcon />,
    color: "#2DD4BF", // Teal
  },
  {
    path: ROUTES.USERS,
    name: "Người dùng",
    icon: <TwoPeopleIcon />,
    color: "#6366F1", // Indigo
  },
  {
    path: ROUTES.GROUPS,
    name: "Nhóm / Trung tâm",
    icon: <GroupIcon />,
    color: "#2DD4BF", // Teal
  },
  {
    path: ROUTES.CMS_SPEECHACE_BILLING,
    name: "Thống kê SpeechAce",
    icon: <AnalyticsIcon />,
    color: "#3B82F6",
  },
  {
    path: ROUTES.CMS_AI_BILLING,
    name: "Thống kê Sử dụng AI",
    icon: <AnalyticsIcon />,
    color: "#10B981",
  },
  {
    path: ROUTES.QUESTION_TYPE_CMS,
    name: "Học theo dạng câu hỏi",
    icon: <QuizIcon />,
    color: "#10B981", // Emerald
  },
  {
    path: ROUTES.CMS_COURSE,
    name: "Khóa học",
    icon: <SchoolIcon />,
    color: "#F59E0B", // Amber
  },
  {
    path: ROUTES.TOPIC_QUESTION,
    name: "Chủ đề & Câu hỏi",
    icon: <QuestionIcon />,
    color: "#8B5CF6", // Violet
  },
  {
    path: ROUTES.QUESTION_PART2,
    name: "Câu hỏi Part 2",
    icon: <Diversity1Icon />,
    color: "#3B82F6", // Blue
  },
  {
    path: ROUTES.CMS_LEARN_VOCA,
    name: "Học từ vựng",
    icon: <SchoolIcon />,
    color: "#EC4899", // Pink
  },
  {
    path: ROUTES.CATEGORY_ASPECT,
    name: "Phân loại & Khía cạnh",
    icon: <IdeaIcon />,
    color: "#2DD4BF",
  },
  {
    path: ROUTES.CMS_WORDBANK,
    name: "Ngân hàng từ",
    icon: <AccountBalanceIcon />,
    color: "#F97316", // Orange
  },
  {
    path: ROUTES.CHALLENGE_CMS,
    name: "Thử thách",
    icon: <AssignmentIcon />,
    color: "#EF4444", // Red
  },
  {
    path: ROUTES.CMS_IELTS_EXAMS,
    name: "IELTS Đề thi",
    icon: <QuizIcon />,
    color: "#3B82F6", // Blue
  },
  {
    path: ROUTES.CMS_IELTS_SUBMISSIONS,
    name: "Kết quả thi IELTS",
    icon: <AssignmentIcon />,
    color: "#10B981", // Emerald
  },
  {
    path: ROUTES.CMS_WRITING_QUESTIONS,
    name: "IELTS Đề viết",
    icon: <EditIcon />,
    color: "#EC4899", // Pink
  },
  {
    path: ROUTES.CMS_SUPPLEMENTARY_EXERCISES,
    name: "IELTS Bài tập bổ trợ",
    icon: <QuizIcon />,
    color: "#F59E0B", // Amber
  },
  {
    path: ROUTES.CMS_CAMBRIDGE_FLASHCARDS,
    name: "Cambridge Flashcards",
    icon: <MenuBookIcon />,
    color: "#8B5CF6", // Violet
  },
  {
    path: ROUTES.PERSONALIZED_CMS,
    name: "Cá nhân hóa",
    icon: <SensorOccupiedIcon />,
    color: "#A855F7", // Purple
  },
  {
    path: ROUTES.GRAMMAR_CMS,
    name: "Ngữ pháp AI",
    icon: <AbcIcon />,
    color: "#6366F1",
  },
  {
    path: ROUTES.CMS_GRAMMAR_BOOKS,
    name: "Ngữ pháp Hệ thống",
    icon: <MenuBookIcon />,
    color: "#10B981",
  },
  {
    path: ROUTES.CMS_PRONUNCIATION_HISTORY,
    name: "Lịch sử phát âm",
    icon: <RecordVoiceOverIcon />,
    color: "#10B981",
  },
  {
    path: ROUTES.AI_CALL_STATIS_CMS,
    name: "Thống kê gọi AI",
    icon: <AnalyticsIcon />,
    color: "#2DD4BF",
  },
  {
    path: ROUTES.CMS_AI_TESTER,
    name: "Kiểm tra AI",
    icon: <AnalyticsIcon />,
    color: "#8B5CF6",
  },
  {
    path: ROUTES.CMS_PACKAGE,
    name: "Quản lý Gói",
    icon: <CardMembershipIcon />,
    color: "#3B82F6",
  },
  {
    path: ROUTES.CMS_TRANSACTION,
    name: "Lịch sử giao dịch",
    icon: <AccountBalanceIcon />,
    color: "#F97316",
  },
  {
    path: ROUTES.CMS_WEBHOOK_LOG,
    name: "Lịch sử Webhook",
    color: "#64748B", // Slate
  },
  {
    path: ROUTES.CMS_EMAIL_TEMPLATE,
    name: "Cấu hình Email",
    icon: <MailIcon />,
    color: "#0EA5E9",
  },
  {
    path: ROUTES.CMS_FORECAST,
    name: "Quản lý Forecast",
    icon: <AnalyticsIcon />,
    color: "#F59E0B", // Amber
  },
  {
    path: ROUTES.CMS_ASPECT_STRUCTURES,
    name: "Cấu trúc khía cạnh",
    icon: <AccountTreeIcon />,
    color: "#6366F1", // Indigo
  },
  {
    path: ROUTES.CMS_COMMON_STRUCTURES,
    name: "Từ vựng chung",
    icon: <FolderSpecialIcon />,
    color: "#10B981", // Emerald
  },
  {
    path: ROUTES.CMS_PROMPT_MANAGEMENT,
    name: "Quản lý Prompt AI",
    icon: <PsychologyIcon />,
    color: "#8B5CF6", // Purple
  },
  {
    path: ROUTES.CMS_USER_REPORTS,
    name: "Báo cáo Sự cố / Ticket",
    icon: <BugReportIcon />,
    color: "#F97316", // Orange
  },
  {
    path: "logout",
    name: "Đăng xuất",
    icon: <LogoutIcon />,
    color: "#EF4444",
  },
];

export default function Layout(props: Props) {
  const { children } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const appMode = useSelector((state: IApplicationState) => state.appMode);
  const isDark = appMode === "dark";
  const [isClosing, setIsClosing] = useState(false);
  const [selectedTab, setSelectedTab] = useState("");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const currentInfoUser = useSelector((state: IApplicationState) => state.currentUser);

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const handleSidebarToggle = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const handleLogout = () => {
    localStorage.removeItem(KeyTokenName);
    window.location.href = "/login";
  };

  const toggleTheme = () => {
    dispatch({ type: AllTypeActions.SET_APP_MODE, payload: isDark ? "light" : "dark" });
  };

  const handleTabClick = (path: string) => {
    setSelectedTab(path);
    if (path === "logout") {
      Swal.fire({
        title: "Bạn có chắc chắn muốn đăng xuất?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Hủy",
        confirmButtonText: "Đăng xuất",
        background: isDark ? "#1e293b" : "#fff",
        color: isDark ? "#fff" : "#0f172a",
        confirmButtonColor: "#EF4444",
        cancelButtonColor: isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
      }).then((result) => {
        if (result.isConfirmed) {
          handleLogout();
        }
      });
    } else {
      navigate(path);
    }
    if (mobileOpen) {
      setMobileOpen(false);
    }
  };

  const drawer = (
    <div>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          padding: "12px",
          bgcolor: "transparent",
        }}
      >
        <IconButton
          onClick={handleSidebarToggle}
          size="small"
          sx={{ color: isDark ? "rgba(255, 255, 255, 0.5)" : "rgba(15, 23, 42, 0.5)" }}
        >
          {sidebarCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </Box>
      <Divider sx={{ borderColor: isDark ? "rgba(255, 255, 255, 0.08)" : "rgba(15, 23, 42, 0.08)" }} />
      <List>
        {dashboardRoutes.map((item, index) => {
          if (currentInfoUser.data?.role === ERole.ADMIN && item.path === ROUTES.USERS) {
            return null;
          }
          if (item.path === ROUTES.GROUPS && currentInfoUser.data?.role !== ERole.SUPER_ADMIN) {
            return null;
          }
          const isActive = selectedTab === item.path;
          return (
            <React.Fragment key={index}>
              {item.path === "logout" ? (
                <Divider sx={{ borderColor: isDark ? "rgba(255, 255, 255, 0.08)" : "rgba(15, 23, 42, 0.08)", my: 1 }} />
              ) : null}
              <ListItem disablePadding>
                <ListItemButton
                  onClick={() => handleTabClick(item.path)}
                  selected={isActive}
                  sx={{
                    justifyContent: sidebarCollapsed ? "center" : "flex-start",
                    minHeight: 48,
                    borderRadius: "12px",
                    mx: 1,
                    mb: 0.5,
                    transition: "all 0.3s ease",
                    position: "relative",
                    overflow: "hidden",
                    "&.Mui-selected": {
                      bgcolor: isDark ? "rgba(255, 255, 255, 0.05)" : "rgba(15, 23, 42, 0.05)",
                      "&::after": {
                        content: '""',
                        position: "absolute",
                        left: 0,
                        top: "20%",
                        bottom: "20%",
                        width: "3px",
                        bgcolor: (item as any).color || "#2DD4BF",
                        borderRadius: "0 4px 4px 0",
                      },
                      "&:hover": {
                        bgcolor: isDark ? "rgba(255, 255, 255, 0.08)" : "rgba(15, 23, 42, 0.08)",
                      },
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      marginRight: sidebarCollapsed ? 0 : "12px",
                      minWidth: "auto",
                      justifyContent: "center",
                      color: isActive
                        ? (item as any).color || "#2DD4BF"
                        : isDark
                          ? "rgba(255, 255, 255, 0.5)"
                          : "rgba(15, 23, 42, 0.5)",
                      transition: "color 0.3s ease",
                      "& svg": { fontSize: isActive ? "22px" : "20px" },
                    }}
                  >
                    {item.icon ?? <MailIcon />}
                  </ListItemIcon>
                  {!sidebarCollapsed && (
                    <ListItemText
                      primary={item.name}
                      primaryTypographyProps={{
                        sx: {
                          fontWeight: isActive ? 700 : 500,
                          fontSize: "14px",
                          color: isActive
                            ? isDark
                              ? "#fff"
                              : "#0f172a"
                            : isDark
                              ? "rgba(255, 255, 255, 0.6)"
                              : "rgba(15, 23, 42, 0.6)",
                        },
                      }}
                    />
                  )}
                </ListItemButton>
              </ListItem>
            </React.Fragment>
          );
        })}
      </List>
    </div>
  );

  useEffect(() => {
    if (currentInfoUser.data) {
      if (currentInfoUser.data?.role === ERole.USER) {
        navigate(ROUTES.LOGIN);
      }
    }
  }, [currentInfoUser.data, navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        overflow: "hidden",
        bgcolor: isDark ? "#020617" : "#F8FAFC",
        minHeight: "100vh",
        position: "relative",
        transition: "background-color 0.3s ease",
      }}
    >
      <CssBaseline />

      {/* Decorative ambient glows */}
      <Box
        sx={{
          position: "fixed",
          top: "10%",
          right: "-5%",
          width: "30%",
          height: "30%",
          background: "radial-gradient(circle, rgba(45, 212, 191, 0.03) 0%, transparent 70%)",
          filter: "blur(80px)",
          zIndex: 0,
          pointerEvents: "none",
        }}
      />
      <Box
        sx={{
          position: "fixed",
          bottom: "10%",
          left: "-5%",
          width: "30%",
          height: "30%",
          background: "radial-gradient(circle, rgba(99, 102, 241, 0.03) 0%, transparent 70%)",
          filter: "blur(80px)",
          zIndex: 0,
          pointerEvents: "none",
        }}
      />

      <AppBar
        position="fixed"
        sx={{
          width: "100%",
          left: 0,
          right: 0,
          ml: 0,
          bgcolor: isDark ? "rgba(2, 6, 23, 0.7)" : "rgba(255, 255, 255, 0.7)",
          backdropFilter: "blur(20px)",
          zIndex: 10,
          boxShadow: "none",
          borderBottom: `1px solid ${isDark ? "rgba(255, 255, 255, 0.05)" : "rgba(15, 23, 42, 0.05)"}`,
          transition: "all 0.3s ease",
        }}
      >
        <Toolbar
          sx={{
            width: "100%",
            px: { xs: 2, sm: 4 }, // Add horizontal padding for professional look
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" }, color: isDark ? "#fff" : "#0f172a" }}
          >
            <MenuIcon />
          </IconButton>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <img
                src={logoIcon}
                style={{
                  width: "32px",
                  height: "32px",
                  filter: isDark ? "drop-shadow(0 0 8px rgba(13, 148, 136, 0.4))" : "none",
                }}
              />
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 900,
                  letterSpacing: "-0.02em",
                  textTransform: "none",
                  background: isDark
                    ? "linear-gradient(to right, #fff, #94a3b8)"
                    : "linear-gradient(to right, #0f172a, #334155)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                fongfluency lab{" "}
                <span style={{ color: "#2DD4BF", fontSize: "12px", opacity: 0.8, letterSpacing: "0.1em" }}>ADMIN</span>
              </Typography>
            </Box>

            <Tooltip title={isDark ? "Chuyển sang chế độ sáng" : "Chuyển sang chế độ tối"}>
              <IconButton
                onClick={toggleTheme}
                sx={{
                  color: isDark ? "#fff" : "#0f172a",
                  bgcolor: isDark ? "rgba(255, 255, 255, 0.05)" : "rgba(15, 23, 42, 0.05)",
                  border: `1px solid ${isDark ? "rgba(255, 255, 255, 0.1)" : "rgba(15, 23, 42, 0.1)"}`,
                  borderRadius: "12px",
                  mr: 6,
                  "&:hover": {
                    bgcolor: isDark ? "rgba(255, 255, 255, 0.1)" : "rgba(15, 23, 42, 0.1)",
                  },
                }}
              >
                {isDark ? <LightModeIcon /> : <DarkModeIcon />}
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        sx={{
          width: { sm: sidebarCollapsed ? "90px" : "270px" },
          flexShrink: { sm: 0 },
          position: "relative",
          zIndex: 5,
        }}
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              bgcolor: isDark ? "#0f172a" : "#fff",
              backgroundImage: "none",
              borderRight: isDark ? "1px solid rgba(255, 255, 255, 0.05)" : "1px solid rgba(15, 23, 42, 0.08)",
              color: isDark ? "rgba(255, 255, 255, 0.7)" : "rgba(15, 23, 42, 0.7)",
            },
          }}
        >
          {drawer}
          <Box sx={{ p: 3, textAlign: "center", opacity: 0.5, fontSize: "12px" }}>v{appVersion}</Box>
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: sidebarCollapsed ? collapsedDrawerWidth : drawerWidth,
              top: "75px",
              bgcolor: isDark ? "rgba(15, 23, 42, 0.4)" : "rgba(255, 255, 255, 0.8)",
              backdropFilter: "blur(20px)",
              border: `1px solid ${isDark ? "rgba(255, 255, 255, 0.05)" : "rgba(15, 23, 42, 0.05)"}`,
              borderRadius: "20px",
              left: "15px",
              height: "calc(100% - 95px)",
              zIndex: 1,
              transition: "all 0.3s ease",
              boxShadow: isDark ? "0 10px 30px -10px rgba(0,0,0,0.5)" : "0 10px 30px -10px rgba(0,0,0,0.1)",
              overflowX: "hidden",
            },
          }}
          open
        >
          {drawer}
          <Box sx={{ mt: "auto", p: 2, textAlign: "center", opacity: 0.5, fontSize: "11px", letterSpacing: "0.05em" }}>
            {appVersion}
          </Box>
        </Drawer>
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { xs: "100%", sm: 0 },
          height: "calc(100vh - 75px)",
          overflowY: "auto",
          marginTop: "75px",
          transition: "all 0.3s ease",
          position: "relative",
          zIndex: 1,
        }}
      >
        {children}
      </Box>
      <ChatAIPopup />
    </Box>
  );
}
